// extracted by mini-css-extract-plugin
export default {"label":"MbJWQMQXFxr5eGbFGEPB","icon":"r5A1Skr_mWoSrJlwBfCD","link":"HogmGcjLPa91hqRFOPgv","disabled":"TY710bKVm9V0ItHm7uUW"};